import React, { useState } from "react";
import ImagemFukyo from "../Imagem-Fukyo/Imagem-Fukyo";
import { withRouter, } from "react-router-dom";
import moment from "moment";
import { Configurations } from "../../Utils/Configurations";
import axios from "axios";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";


const PodcastHighLightCard = (props) => {

    const { conteudo, history, setLoading, indice, size, chamadaDestaques } = props;

    const [modalExcluir, setModalExcluir] = useState(false);
    const [loadingExcluir, setLoadingExcluir] = useState(false);
    const [itemExcluir, setItemExcluir] = useState(null);

    const editDestaque = (conteudo) => {
        history.push({
            pathname: `podcasts/detalhes/${conteudo._id}`,
            state: { conteudo }
        });
    };

    const alteraPosicao = (item, direcao) => {
        setLoading(true)
        const _body = {

            plataforma: "Hub",
            tipo: "podcast",
            idsOrdenados: [
                item._id
            ],
            posicao: item.posicao + direcao
        }

        const config = new Configurations();
        axios.patch(config.apiBasePath + `/destaques-videos-podcasts/reordenar`, _body)
            .then((response) => {
                chamadaDestaques()
            })
            .catch(err => {
                console.log("ERROR: ", err)
                setLoading(false)
            })
            .finally()
    }

    const toggleVisivel = (item) => {
        const _body = {
            ativo: !item.ativo,
        };

        const config = new Configurations();
        axios.patch(config.apiBasePath + `/destaques-videos-podcasts/${item._id}/status`, _body)
            .then((response) => {
                chamadaDestaques()
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {
            });
    }

    const toggleModalExcluir = (item) => {
        setModalExcluir(!modalExcluir)
        setItemExcluir(item)
    }

    const deleteDestaque = (item) => {
        setLoadingExcluir(true);

        const config = new Configurations();
        axios.delete(config.apiBasePath + `/destaques-videos-podcasts/${item._id}`)
            .then((response) => {
                setLoadingExcluir(false)
                chamadaDestaques()
            })
            .catch(error => {
                console.log("ERROR: ", error)
                setLoadingExcluir(false)
            })
            .finally(() => {
            });
    }


    return (
        conteudo &&
        <>
            <div className="content-product pt-2 mt-3">
                <div className="card bg-white">
                    <div className={`${conteudo.ativo ? 'bg-purple' : 'bg-secondary'} text-white card-header`}>
                        <div className="row no-gutters">
                            <div className="col-4 border-white">
                                <span className="tipo-label d-flex align-items-center">
                                    Destaque
                                </span>
                            </div>
                            <div className="col-4 d-none d-md-block text-center">
                                <button className="btn btn-outline-light" type="button" onClick={() => editDestaque(conteudo)} >
                                    Editar Destaque
                                </button>
                            </div>
                            <div className="col-4 text-right border-white d-flex justify-content-end align-items-center">
                                <i className={`far fa-eye-slash icones-destaques-ativos cursor-pointer`} onClick={() => toggleVisivel(conteudo)}></i>

                                <span className={`${conteudo.ativo ? 'text-purple' : 'text-secondary'} mx-3 badge bg-white`}>{conteudo.ativo ? 'Disponível' : 'Indisponível'}</span>
                                {conteudo.ativo &&
                                    <>
                                        <i className={'cursor-pointer fas fa-arrow-up icones-destaques-ativos px-3 ' + (indice === 0 ? 'd-none' : null)} onClick={() => alteraPosicao(conteudo, -1)} ></i>
                                        <i className={'cursor-pointer fas fa-arrow-down icones-destaques-ativos px-3 ' + (indice === (size - 1) ? 'd-none' : null)} onClick={() => alteraPosicao(conteudo, 1)} ></i>
                                    </>
                                }
                                <i className="far fa-trash-alt ml-1 mr-1 cursor-pointer" onClick={() => toggleModalExcluir(conteudo)}></i>
                            </div>
                        </div>
                    </div>
                    <div className="card-body pt-3">
                        <div className="row no-gutters">
                            <div className="col-3 d-lg-block d-none">
                                <ImagemFukyo
                                    className={`img img-fluid`}
                                    src={conteudo.image}
                                    alt={`imagem-destaque`}
                                />
                            </div>
                            <div className="col-lg-9 col-12 px-lg-4 px-0">
                                <p className="infos-ativos"><strong>Título:</strong> {conteudo.dadosConteudo.nome} </p>
                                <p className="infos-ativos"><strong>Descrição:</strong> {conteudo.dadosConteudo.descricao} </p>
                                <p className="infos-ativos"><strong>Data de Publicação:</strong> {moment(conteudo.dadosConteudo.dtPublicacao).format('DD/MM/YYYY')} </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal isOpen={modalExcluir} toggle={toggleModalExcluir} >
                <ModalHeader toggle={toggleModalExcluir}>Remover destaque</ModalHeader>
                <ModalBody>
                    <p className="m-0">Deseja excluir o destaque <strong>{conteudo.dadosConteudo.nome}</strong> da lista de conteúdos?</p>
                </ModalBody>
                <ModalFooter>
                    {loadingExcluir ? (
                        <div className="spinner-border spinner-border-sm text-danger" role="status" />
                    ) : (
                        <Button disabled={loadingExcluir} color={`danger`} onClick={() => deleteDestaque(itemExcluir)}>Excluir</Button>
                    )}
                    {' '}<Button color="secondary" onClick={toggleModalExcluir}>cancelar</Button>
                </ModalFooter>
            </Modal>
        </>
    )
}
export default withRouter(PodcastHighLightCard);